var map = {
	"./agent.png": 37862,
	"./box.png": 27755,
	"./chris.png": 94496,
	"./cube1.png": 87899,
	"./cube2.png": 60530,
	"./frame.png": 90693,
	"./health.png": 88086,
	"./instructions/box2_insert_box.png": 44977,
	"./instructions/box2_insert_key.png": 22573,
	"./instructions/close_final.png": 22255,
	"./instructions/close_keylock_box.png": 11163,
	"./instructions/close_keys.png": 72424,
	"./instructions/close_padlock.png": 82302,
	"./instructions/close_secret.png": 12726,
	"./instructions/fill_artifact.png": 31069,
	"./instructions/insert_box3to2.png": 91709,
	"./instructions/iris_bottom_keys.png": 70761,
	"./instructions/iris_closed.png": 85180,
	"./instructions/iris_insert-key.png": 46521,
	"./instructions/iris_opened.png": 87244,
	"./instructions/paper_box.png": 62506,
	"./magnet.png": 11069,
	"./mrpuzzle.png": 33892,
	"./scientist.png": 52293,
	"./scientist_dead.png": 23552,
	"./scientist_dead_blood.png": 25962,
	"./scientist_glitch.gif": 68959
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44642;